import React, {useState, useEffect, useRef} from 'react'
import {FaAward} from 'react-icons/fa'
import {FiUsers} from 'react-icons/fi'
import {VscFolderLibrary} from 'react-icons/vsc'
import './propos.css'
import img from '../../assets/img-3.png'
import {gsap} from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import ScrollToPlugin from 'gsap/ScrollToPlugin';
import { useLanguage } from '../../contexts/LanguageContext';
import { translations } from '../../translations/translations';
import { motion } from 'framer-motion';

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin)


const Propos = () => {
  const [toggle, setToggle] = useState(false);
  const { language } = useLanguage();
  const t = translations[language];
  
  // Calcul automatique des années d'expérience depuis 2021
  const startYear = 2021;
  const currentYear = new Date().getFullYear();
  const yearsOfExperience = currentYear - startYear;
  
  const changeState = () => {
    setToggle(!toggle)
  }
  const Picture = useRef(null)
  useEffect(() => {
    toggle ?
    gsap.to(Picture.current,
          {
            scale:1.2,
            rotate:360,
            duration:0.9
          }
        )
        :
    gsap.to(Picture.current,
          {
            scale:1,
            rotate:0,
            duration:0.9
          }
        )
  }, [toggle]);


  const Left = (element, delay, duration) => {
        gsap.fromTo(
            element,{
                opacity : 0,
                x: -200
            },
            {
                opacity : 1,
                x: 0,
                delay: delay || "0.3",
                duration: duration || "0.5",
                scrollTrigger:{
                    trigger: element,
                    start: "top center",
                    end: "bottom center"
                }
            }
        )
  }
  useEffect(() => {
        Left("#propos")
    }, []);
    
  return (
    <section id='propos' className='propos'>
      <motion.h5
        initial={{ opacity: 0, y: -50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
      >
        {t.getToKnow}
      </motion.h5>
      
      <motion.h2
        initial={{ opacity: 0, y: -50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.2 }}
        viewport={{ once: true }}
      >
        {t.aboutTitle}
      </motion.h2>
      
      <div className='container propos__container'>
        <motion.div 
          className='propos__me'
          initial={{ opacity: 0, x: -100 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 1, delay: 0.3 }}
          viewport={{ once: true }}
        >
          <motion.img 
            src={img} 
            alt="img_me" 
            className='propos__me-image' 
            onClick={changeState} 
            ref={Picture}
            whileHover={{ 
              scale: 1.05,
              rotate: 5,
              transition: { duration: 0.3 }
            }}
            whileTap={{ scale: 0.95 }}
          />
        </motion.div>
        
        <motion.div 
          className='propos__content'
          initial={{ opacity: 0, x: 100 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 1, delay: 0.5 }}
          viewport={{ once: true }}
        >
          <motion.div 
            className='propos__cards'
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.7 }}
            viewport={{ once: true }}
          >
            <motion.article 
              className='propos__card'
              whileHover={{ 
                scale: 1.1,
                y: -10,
                transition: { duration: 0.3 }
              }}
              whileTap={{ scale: 0.95 }}
            >
              <FaAward className='propos_icon'/>
              <h5>{t.experienceLabel}</h5>
              <small>{yearsOfExperience} {t.years}</small>
            </motion.article>
            
            <motion.article 
              className='propos__card'
              whileHover={{ 
                scale: 1.1,
                y: -10,
                transition: { duration: 0.3 }
              }}
              whileTap={{ scale: 0.95 }}
            >
              <FiUsers className='propos_icon'/>
              <h5>{t.clients}</h5>
              <small>10{t.plus}</small>
            </motion.article>
            
            <motion.article 
              className='propos__card'
              whileHover={{ 
                scale: 1.1,
                y: -10,
                transition: { duration: 0.3 }
              }}
              whileTap={{ scale: 0.95 }}
            >
              <VscFolderLibrary className='propos_icon'/>
              <h5>{t.projects}</h5>
              <small>30{t.plus}</small>
            </motion.article>
          </motion.div>
          
          <motion.p
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.9 }}
            viewport={{ once: true }}
          >
            {t.aboutText}
          </motion.p>

          <motion.a 
            href='#contact' 
            className='btn btn-primary'
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 1.1 }}
            viewport={{ once: true }}
            whileHover={{ 
              scale: 1.05,
              y: -5,
              transition: { duration: 0.2 }
            }}
            whileTap={{ scale: 0.95 }}
          >
            {t.contactMe}
          </motion.a>
        </motion.div>
      </div>
    </section>
  )
}

export default Propos